



















































































import { defineComponent, ref } from "@vue/composition-api";
import useFileSize from "@/hooks/useCheckFileSize";
import useUploadedFilePreview from "@/hooks/useUploadedFilePreview";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import BaseInputFileWithPreview from "@/components/BaseInputFileWithPreview";
import DragDropFiles from "@/components/DragDropFiles";
import UploadedFilesEditModal from "@/components/UploadedFilesEditModal";

export default defineComponent({
  name: "EditPostDropZone",
  components: { UploadedFilesEditModal, BaseInputFileWithPreview, BaseInputFile, BaseButton, BaseIcon, DragDropFiles },
  props: {
    multiple: { type: Boolean },
    allowedFileTypes: { type: Array as () => string[], required: true },
    showDropZone: { type: Boolean, required: true },
    dragAndDropProhibited: { type: Boolean, default: false },
    nativeUploadingAvailable: { type: Boolean, default: true },
    useStereoFiles: { type: Boolean, default: false },
  },
  setup() {
    const isDrag = ref(false);
    const {
      files: droppedFiles,
      updateUploadedFile,
      removeFileFromUploadedList,
      uploadFiles,
    } = useUploadedFilePreview();

    const { checkFilesSize } = useFileSize();

    const onDragHandler = (v: boolean) => {
      isDrag.value = v;
    };

    const onDropFiles = (files: File[]) => {
      droppedFiles.value = checkFilesSize(files);
    };

    return {
      isDrag,
      onDragHandler,
      droppedFiles,
      onDropFiles,
      uploadFiles,
      updateUploadedFile,
      removeFileFromUploadedList,
    };
  },
});
